import React, { Component } from 'react'

//Styles
import './desenvolvimento.scss'

export default class Desenvolvimento extends Component {
    render() {
        return (
            <div className="desenvolvimento-container">

                <div className="desenvolvimetno-text-container">

                    <h1 className="desenvolvimento-title">Em Desenvovimento</h1>

                </div>


            </div>
        )
    }
}